export const CHANNEL_TYPES = {
  audio: 0, // 语音频道,
  text: 1, // 文字频道
  notice: 2, // 公告频道
  group: 3, // 分组
  temporary: 4, // 临时频道
  temporary_group: 5, // 临时频道组
  custom: 6, // 自定义频道，通过url加载组件
  post: 7, // 帖子频道
  mp: 8, // 小程序频道
  
  experiment: 999, // 定制频道和权限组，静态频道组件
  hide_channels: 1000, // 隐藏频道，静态频道组件
  room_activity_btn: 1001, // 活动按钮，静态频道组件
  room_activity_interval: 1002, // 活动频道，静态频道组件
  guidance: 1003, // 房间指南，静态频道组件
  room_anc: 1004, // 房间公告，静态频道组件
  global_team: 1005, // 全局组队，静态频道组件

  has_audio_types: [0, 4], // 有语音的频道类型
  only_text_types: [1, 2, 7], // 纯IM的频道类型
  temp_types: [4, 5], //临时图标频道类型
  can_edit_types: [0, 1, 2, 5], // 可以在频道管理编辑的类型
  can_edit_audio_types: [0, 5], // 可以在频道管理编辑音频设置的频道类型
  can_show_in_manage_types: [0, 1, 2, 3, 5, 6, 7, 8], // 可以在频道管理显示的类型
}

export const CHANNEL_SET_RECOMMEND_SET_ONLY_AT_TYPES = {
  none: 0,
  need_show: 1,
  showed: 2,
}

export const getChannelIcon = (item) => {
  if (!item) {
    console.error('[getChannelIcon] item is not defined')
    return ''
  }
  if (item.password) {
    if (item.channel_type === CHANNEL_TYPES.audio) {
      return 'icon-voice-locked'
    } else if (item.channel_type === CHANNEL_TYPES.text) {
      return 'icon-topic-locked-bold'
    }
  }
  if (item.is_private) {
    if (item.channel_type === CHANNEL_TYPES.audio) {
      return 'icon-voice-restricted'
    } else if (item.channel_type === CHANNEL_TYPES.text) {
      return 'icon-topic-restricted-bold'
    }
  }
  if (item.channel_type === CHANNEL_TYPES.text) {
    return 'icon-topic-bold'
  } else if (item.channel_type === CHANNEL_TYPES.notice) {
    return 'icon-horn'
  } else if (item.channel_type === CHANNEL_TYPES.temporary) {
    return 'icon-voice-tmp'
  } else if (item.channel_type === CHANNEL_TYPES.temporary_group) {
    return 'icon-add-bold'
  } else if (item.channel_type === CHANNEL_TYPES.post) {
    return 'icon-bbs'
  } else if (item.channel_type === CHANNEL_TYPES.custom) {
    return "icon-topic-bold " + item.channel_icon;
  } else if (item.channel_type === CHANNEL_TYPES.experiment) {
    return "icon-list-bold " + item.channel_icon;
  } else if (item.channel_list && item.channel_list.length) {
    return "icon-file";
  }{
    return 'icon-speak-on'
  }
}

export const CHANNEL_SHOW_UNREAD_COUNT = [1, 2] // 文字频道和公告频道需要显示红点
export const CHANNEL_USER_DRAG_TYPE = 'dragleuser/user' // 频道内用户拖拽事件名称
export enum CHANNEL_USER_UPDATE_MOVE_TYPE {
  JOIN,
  LEAVE,
}

export const CHANNEL_USER_ACTIVE_VOLUME = 60 // 频道里用户的音量值大于多少展示绿圈

export const STATIC_CHANNEL_ID = {
  experiment: 'experiment',
  room_anc: 'room_anc',
  room_anc_banner: 'room_anc_banner',
  hide_channels: 'hide_channels',
  room_act_btn: 'room_act_btn',
  room_act_activity: 'room_act_activity',
  bottom_padding: 'bottom_padding',
  guidance: 'guidance',
  global_team: 'global_team',
}

/**
 * 频道转移时的值
 */
export const GROUP_OPTION_VALUE = {
  NEW: '-999', // 转移至新分组
  NO: '0', // 转移至无分组
}

// 多人语音折叠的人数
export const COLLAPSE_MEMBER_COUNT = 10

export const USER_LIST_STATES = {
  ALL: 'all',
  COLLAPSE_BY_COUNT: 'collapse_by_count',
  COLLAPSE_BY_ROOM_COLLAPSE: 'collapse_by_room_collapse',
}

export const CHANNEL_DOM_STATE = {
  IN_WINDOW: 1,
  OUT_WINDOW: 2,
  NOT_EXIST: 3,
  HIDE: -1,
}

export const DEFAULT_CHANNEL_PAGE_SIZE = 50 // 频道列表每次加载条数
export const DEFAULT_CHANNEL_PAGE_MAX_COUNT = 150 // 频道列表储存最多列表值

export const MAX_CHANNEL_SIDEBAR_WIDTH = 360 // 频道侧边栏最大宽度
export const MIN_CHANNEL_SIDEBAR_WIDTH = 240 // 频道侧边栏最小宽度

// 获取所有有效的频道类型
export const getAllChannelTypes = () => {
  const channelTypeValues = Object.values(CHANNEL_TYPES);
  return channelTypeValues.filter((item) => {
    if (Array.isArray(item)) {
      return false;
    }
    if(item >= CHANNEL_TYPES.experiment) {
      return false;
    }
    return true;
  });
}

export const COMMON_CPT_PADDING = 16 // 通用组件的padding值
